import React from "react";
import { observer } from "mobx-react";
import { PatientMissingDocsSearchTemplate } from "themes/application/patient-missing-docs/pages";
import { PatientMissingDocsSearchViewStore } from "application/patient-missing-docs/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new PatientMissingDocsSearchViewStore(rootStore), "patientMissingDocsSearchViewStore")
@observer
class PatientMissingDocsSearch extends React.Component {
	render() {
		return <PatientMissingDocsSearchTemplate {...this.props} />;
	}
}

export default PatientMissingDocsSearch;